import { SortDirection } from 'components/Table/types';
import apiClient from './api/apiService';
import { getUrlWithQueryParams } from './api/getUrlWithQueryParams';
import { AppMode } from 'store/Common/reducers/common';

const BASE_URL = '/v1/orders';

export const getOrders = async (
  appMode: AppMode,
  companyId: number,
  page?: number,
  perPage?: number,
  searchBy?: string,
  sortBy?: string,
  sortDirection?: SortDirection
): Promise<any> => {
  const queryParamsObj = {
    ...(appMode === AppMode.SUPPLIER && { company_seller_id: companyId }),
    ...(appMode === AppMode.BUYER && { company_buyer_id: companyId }),
    page: page,
    per_page: perPage,
    search_term: searchBy,
    sort_by: sortBy,
    sort_direction: sortDirection,
  };
  const url = `${BASE_URL}`;
  const fullUrl = getUrlWithQueryParams(url, queryParamsObj);
  const { data } = await apiClient.get<any>(fullUrl);
  return data.data;
};

export const getOrderById = async (
  id: string,
  appMode?: AppMode
): Promise<any> => {
  const url = `${BASE_URL}/${id}`;
  const { data } = await apiClient.get<any>(url, {
    params: {
      ...(appMode === AppMode.BUYER && { company_mode: AppMode.BUYER }),
    },
  });
  return data.data;
};

export const changeOrderStatus = async (
  id: string,
  status: string
): Promise<any> => {
  const url = `${BASE_URL}/${id}`;
  const { data } = await apiClient.patch<any>(url, {
    status,
  });

  return data.data;
};

export const retryOrder = async (id: string): Promise<any> => {
  const url = `${BASE_URL}/${id}/resend`;
  const { data } = await apiClient.post<any>(url);

  return data.data;
};
